import TemporalDiff from "./temporalDiff.service";

angular.module("acl.visualizer.temporalDiff", []).service("TemporalDiff", TemporalDiff);
